<div class="step-container">
  <h2 class="step-title">Referencias personales</h2>
  <p class="step-subtitle">Ingrese los datos de 2 personas que puedan dar referencias suyas.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
    <!-- Reference 1 -->
    <div class="reference-section">
      <h3 class="reference-title">Referencia 1</h3>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nombre completo</mat-label>
        <input
          matInput
          formControlName="ref1FullName"
          type="text"
          placeholder="Nombre y apellido" />
        <mat-icon matPrefix>person</mat-icon>
        <mat-error *ngIf="form.get('ref1FullName')?.hasError('required')">
          El nombre es obligatorio.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Relación / Vínculo</mat-label>
        <input
          matInput
          formControlName="ref1Relationship"
          type="text"
          placeholder="Ej: Familiar, Amigo, Compañero de trabajo" />
        <mat-icon matPrefix>people</mat-icon>
        <mat-error *ngIf="form.get('ref1Relationship')?.hasError('required')">
          La relación es obligatoria.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Celular</mat-label>
        <input
          matInput
          formControlName="ref1MobilePhone"
          type="tel"
          placeholder="Ej: 1155667788"
          inputmode="tel" />
        <mat-icon matPrefix>phone</mat-icon>
        <mat-error *ngIf="form.get('ref1MobilePhone')?.hasError('required')">
          El celular es obligatorio.
        </mat-error>
        <mat-error *ngIf="form.get('ref1MobilePhone')?.hasError('pattern')">
          Ingrese un número argentino válido.
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Reference 2 -->
    <div class="reference-section">
      <h3 class="reference-title">Referencia 2</h3>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nombre completo</mat-label>
        <input
          matInput
          formControlName="ref2FullName"
          type="text"
          placeholder="Nombre y apellido" />
        <mat-icon matPrefix>person</mat-icon>
        <mat-error *ngIf="form.get('ref2FullName')?.hasError('required')">
          El nombre es obligatorio.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Relación / Vínculo</mat-label>
        <input
          matInput
          formControlName="ref2Relationship"
          type="text"
          placeholder="Ej: Familiar, Amigo, Compañero de trabajo" />
        <mat-icon matPrefix>people</mat-icon>
        <mat-error *ngIf="form.get('ref2Relationship')?.hasError('required')">
          La relación es obligatoria.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Celular</mat-label>
        <input
          matInput
          formControlName="ref2MobilePhone"
          type="tel"
          placeholder="Ej: 1155667788"
          inputmode="tel" />
        <mat-icon matPrefix>phone</mat-icon>
        <mat-error *ngIf="form.get('ref2MobilePhone')?.hasError('required')">
          El celular es obligatorio.
        </mat-error>
        <mat-error *ngIf="form.get('ref2MobilePhone')?.hasError('pattern')">
          Ingrese un número argentino válido.
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="action-button"
      type="submit"
      [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">Guardar referencias</span>
    </button>
  </form>
</div>
